import { BILLING_PRICES } from "@reflect/domain";

const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

/**
 * A public price card's amount (`$7`) from the domain catalogue.
 *
 * The period beside it (`/ month`, `one time`) is copy, so it lives in the
 * catalog under `web.home.pricing.plans.<priceKey>.period`.
 *
 * @param {string} priceKey - a `BILLING_PRICES` key.
 */
export function billingAmount(priceKey) {
  return currency.format(BILLING_PRICES[priceKey].amountMinor / 100);
}
